import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { RECORD_MANAGER } from '../../services/record.provide';
import { REPRESENTATION_MODE } from '../../services/representation-mode.service';
import { LvrButton } from '../lvr-button/lvr-button';

@Component({
	selector: 'lvr-representation-banner',
	imports: [MatButtonModule, MatIconModule, TranslocoPipe, LvrButton],
	templateUrl: './representation-banner.html',
	styleUrl: './representation-banner.scss',
})
export class RepresentationBanner {
	private readonly representationMode = inject(REPRESENTATION_MODE);
	private readonly recordManager = inject(RECORD_MANAGER);
	private readonly router = inject(Router);
	public readonly isActive = this.representationMode.isActive;
	public readonly label = computed(() => this.representationMode.mode().representedUserName);

	public endRepresentation() {
		// Close current representation tabs, deactivates representation mode and switches to default record manager context
		this.recordManager.closeAllRecords();
		this.representationMode.deactivate();
		this.recordManager.switchToDefaultContext();
		void this.router.navigate(['/']);
	}
}
